export default "__VITE_ASSET__Bo5terTV__"